<div role="group" [attr.aria-labelledby]="headingKey || null">
  <div class="mb-0.5 flex min-h-[24px] items-center justify-between gap-1">
    @if (headingKey) {
    <h2
      [id]="headingKey"
      class="!m-0 !max-w-none !font-base !text-base !font-semibold !leading-[22px]"
    >
      {{ headingKey | translate }}
    </h2>
    }
    <div class="ml-auto flex shrink-0 gap-0.5 has-[.swiper-button-lock]:hidden">
      <button
        #previousButton
        appPointerHover
        type="button"
        class="flex h-[24px] w-[32px] cursor-pointer items-center justify-center rounded-md bg-black/5 text-black transition-opacity dark:bg-white/5 dark:text-white [&.is-pointer-hovered]:bg-black/10 dark:[&.is-pointer-hovered]:bg-white/10 [&.swiper-button-disabled]:pointer-events-none [&.swiper-button-disabled]:opacity-30 [&.swiper-button-lock]:hidden"
        [attr.aria-label]="'COMPASS_RESULTS_PREVIOUS' | translate"
      >
        <span
          aria-hidden="true"
          class="block h-[16px] w-[16px] rotate-180 bg-current mask-[url(/assets/images/icons/chevron-right.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        ></span>
      </button>
      <button
        #nextButton
        appPointerHover
        type="button"
        class="flex h-[24px] w-[32px] cursor-pointer items-center justify-center rounded-md bg-black/5 text-black transition-opacity dark:bg-white/5 dark:text-white [&.is-pointer-hovered]:bg-black/10 dark:[&.is-pointer-hovered]:bg-white/10 [&.swiper-button-disabled]:pointer-events-none [&.swiper-button-disabled]:opacity-30 [&.swiper-button-lock]:hidden"
        [attr.aria-label]="'COMPASS_RESULTS_NEXT' | translate"
      >
        <span
          aria-hidden="true"
          class="block h-[16px] w-[16px] bg-current mask-[url(/assets/images/icons/chevron-right.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        ></span>
      </button>
    </div>
  </div>
  <swiper-container
    #entitySwiper
    init="false"
    class="block min-w-0"
    [style.mask-image]="getHorizontalOverflowMask(overflowStart, overflowEnd)"
  >
    @for (entity of entities; track getEntitySuggestionKey(entity)) { @let
    active = isSelected(entity);
    <swiper-slide class="!h-auto self-start">
      <button
        appPointerHover
        type="button"
        class="flex w-full cursor-pointer items-center gap-1 rounded-xl p-1 text-left transition-colors [&.is-pointer-hovered]:bg-black/5 dark:[&.is-pointer-hovered]:bg-white/5"
        [ngClass]="{'bg-primary/15 ring-1 ring-inset ring-primary': active}"
        [attr.aria-pressed]="active"
        [title]="entity.name"
        (click)="toggled.emit(entity)"
      >
        <app-user-avatar
          class="shrink-0"
          [name]="entity.name"
          [picture]="getPicture(entity)"
          [size]="isMobile ? 32 : 40"
        />
        <span class="min-w-0 [overflow-wrap:anywhere]">
          <span
            class="text-base font-semibold leading-[20px]"
            [ngClass]="isMobile ? 'line-clamp-2' : 'block'"
            >{{ entity.name }}</span
          >
          <span
            class="mt-[2px] inline-block max-w-full rounded-md bg-black/10 px-0.5 py-[2px] text-sm leading-[16px] text-greyer dark:bg-white/5 dark:text-borders-dark"
          >
            {{ roleLabelKey(entity, isMobile) | translate }}
            @let scope = scopeLabelKey(entity); @if (scope && !isMobile) {
            <span aria-hidden="true"> · </span>{{ scope | translate }}
            }
          </span>
        </span>
      </button>
    </swiper-slide>
    }
  </swiper-container>
</div>
